import { API } from "../utils";

export const getTags = async ({ params }) => {
  const response = API.get("/organization/tags", { params });
  const data = await response;
  return data;
};

export const createTag = async ({ body }) => {
  const response = API.post("/organization/tags", body);
  const data = await response;
  return data;
};

export const deleteTag = async ({ params }) => {
  const response = API.delete(`/organization/tags/${params.id}`);
  const data = await response;
  return data;
};

export const getSingleTag = async ({ params }) => {
  const response = API.get(`/organization/tags/${params.id}`, { params });
  const data = await response;
  return data;
};

export const updateTag = async ({ params, body }) => {
  const response = API.patch(`/organization/tags/${params.id}`, body);
  const data = await response;
  return data;
};

export const restoreTag = async ({ params }) => {
  const response = API.put(`/organization/tags/${params.id}/restore`);
  const data = await response;
  return data;
};
